import req from './http.js'
import config from '../config'

const baseUrl = !config.app ? config.payBaseUrl.dev : config.payBaseUrl.pro
const javaUrl = !config.app ? config.javaBaseUrl.dev : config.javaBaseUrl.pro
const TypeCommon = { type: '00' }
//  获取钱包信息
export const queryWalletInfo = params => req('post', baseUrl + 'accountQuery/myBurseHome', params || TypeCommon, true)
// 开户
export const registerAccount = params => req('post', baseUrl + 'account/application', params || TypeCommon, true)
// 钱包明细
export const getParticularsList = params => req('post', baseUrl + '/balance/list', params || TypeCommon, true)
// 钱包明细详情
export const getParticularsDetail = params => req('post', baseUrl + '/balance/detail', params, true)
// 申请提现
export const applyForCash = params => req('post', baseUrl + '/accountWithdrawCash/apply', params, true)
// 银行卡列表
export const queryBankCardList = params => req('post', baseUrl + '/accountQuery/queryCardList', params || TypeCommon, true)
// 绑定银行卡发送验证码
export const bindCardSendSms = params => req('post', baseUrl + '/account/applicationAndBinding', params || TypeCommon, true)
// 绑定银行卡
export const bindCard = params => req('post', baseUrl + '/account/applicationAndBindingSms', params || TypeCommon, true)
// 设置默认银行卡
export const setDefault = params => req('post', baseUrl + '/account/setCardDefault', params || TypeCommon, true)
// 提现验证码
export const applyAccountSms = params => req('post', baseUrl + '/accountWithdrawCash/sms', params || TypeCommon, true)
// 提现到卡
export const applyAccount = params => req('post', baseUrl + '/accountWithdrawCash/member', params || TypeCommon, true)
// 订单详情
export const getOrderDetail = params => req('get', javaUrl + 'order/api/v3/baseOrder/orderDetail', params, false)
// 获取交易流水
export const getOrderString = params => req('post', javaUrl + 'order/api/v3/baseOrder/pay', params, false)
// 发送转账短信
export const sendTransferSms = params => req('post', baseUrl + '/sms/sendInform', params, true)
